import React, { useEffect, useState } from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { isUploadedImage } from '../fabricHelpers';

export default function GoogleMapPanel() {
  const { selection, fabricRef, refreshLayers } = useEditor();
  const img = isUploadedImage(selection) ? selection : null;
  const [useGoogleMap, setUseGoogleMap] = useState(false);
  const [useUserGPS, setUseUserGPS] = useState(false);

  useEffect(() => {
    setUseGoogleMap(!!img?.useGoogleMap);
    setUseUserGPS(!!img?.useUserGPS);
  }, [img]);

  const patch = (changes) => {
    if (!img) return;
    img.set(changes);
    fabricRef.current?.renderAll();
    if ('useGoogleMap' in changes) setUseGoogleMap(!!changes.useGoogleMap);
    if ('useUserGPS' in changes) setUseUserGPS(!!changes.useUserGPS);
    refreshLayers?.();
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Google Map" icon="fa-map-location-dot" />
      {!img && (
        <p className="pixie-hint">Select an uploaded image on the canvas to configure map options.</p>
      )}
      {img && (
        <div className="pixie-props">
          <label className="pixie-field pixie-check">
            <input
              type="checkbox"
              checked={useGoogleMap}
              onChange={(e) => {
                if (!e.target.checked) {
                  patch({ useGoogleMap: false, useUserGPS: false });
                  return;
                }
                patch({ useGoogleMap: true });
              }}
            />
            Use Google Map Instead Image
          </label>
          <label className="pixie-field pixie-check">
            <input
              type="checkbox"
              checked={useUserGPS}
              disabled={!useGoogleMap}
              onChange={(e) => patch({ useUserGPS: e.target.checked })}
            />
            Show Current User GPS on Map
          </label>
        </div>
      )}
    </div>
  );
}
